import { SET_ADYEN_CONNECTED_ACCOUNT, SET_PAYMENT_STRIPE_ACCOUNT, SET_PAYPAL_NOTIFICATION, SET_STRIPE_NOTIFICATION, SET_TAP2PAY_NOTIFICATION_MODAL_SHOW } from '../../actionTypes/payment'

const initialState = {
	stripeAccount: null,
	paypalNotification: null,
	stripeNotification: null,
	tap2PayNotificationModalShow: false,
	adyenConnectedAccount: null,
}

export function paymentReducer(state = initialState, action) {
	switch (action.type) {
		case SET_PAYMENT_STRIPE_ACCOUNT:
			return {
				...state,
				stripeAccount: action.value,
			}
		case SET_PAYPAL_NOTIFICATION:
			return {
				...state,
				paypalNotification: action.value,
			}
		case SET_STRIPE_NOTIFICATION:
			return {
				...state,
				stripeNotification: action.value,
			}
		case SET_TAP2PAY_NOTIFICATION_MODAL_SHOW:
			return {
				...state,
				tap2PayNotificationModalShow: action.value,
			}
		case SET_ADYEN_CONNECTED_ACCOUNT:
			return {
				...state,
				adyenConnectedAccount: action.value,
			}
		default:
			return state
	}
}
